<template>
<div>

</div>
</template>

<script>
export default {
name: "CompanyComponent"
}
</script>

<style scoped>

</style>